import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../lib/utils";
import { useCardContext } from "./CardContext";
import { cardBodyVariants, cardRegionVariants } from "./styles";

export interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

/**
 * The card's content region. Holding plain content it is a single padded block; holding
 * `Card.Section`s it hands its padding to them (with a divider between each when the card is
 * `divided`).
 */
export const CardBody = ({ className, ref, ...props }: CardBodyProps) => {
  const { variant, padding, divided } = useCardContext();

  return (
    <div
      ref={ref}
      data-slot="card-body"
      className={cn(
        cardRegionVariants({ variant, padding }),
        cardBodyVariants({ variant, padding, divided }),
        className
      )}
      {...props}
    />
  );
};
